import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    LaneDetails,
} from 'app/Apps/Pricing/Pricing.types'
import laneRequests from 'app/requests/Lane/Lane.requests'

export default (id: number) => {
    return useRequest<LaneDetails>({
        key: RequestKeys.getContractBasisLaneGroupLaneDetails,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(laneRequests.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}
